<p class="label" i18n="@@core.drawing.copy-from-reference-layer">Copy objects from reference layer</p>
@if (referenceLayers().length > 0) {
  <mat-form-field appearance="outline" class="reference-layer">
    <mat-label i18n="@@core.drawing.reference-layer">Reference layer</mat-label>
    <mat-select [formField]="layerForm.layerId">
      @for (layer of referenceLayers(); track layer.id) {
        <mat-option [value]="layer.id">{{layer.title || layer.layerName}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div class="copy-buttons">
    <button mat-stroked-button
            color="primary"
            [class.button--active]="copyFromLayerActive()"
            [attr.aria-pressed]="copyFromLayerActive()"
            [disabled]="!selectedLayerId()"
            i18n-tmTooltip="@@core.drawing.select-objects-to-copy"
            tmTooltip="Click objects on the map to copy them to the drawing"
            (click)="toggleCopyFromLayer()">
      <mat-icon svgIcon="split"></mat-icon>
    </button>
  </div>
} @else {
  <div class="no-reference-layers" i18n="@@core.drawing.no-reference-layers">No visible layers with available geometry</div>
}
